import { useTranslation } from "react-i18next";

export interface BannerProps {
    user?: any;
    oAuthUrl?: string;
}

export default function Banner({ user, oAuthUrl }: BannerProps) {
    const { t } = useTranslation("common");

    return (
        <>
            <nav className="bg-hero bg-cover bg-center dark:bg-gray-900 w-100 px-8 md:px-auto h-[370px] flex items-center">
                <div className="max-w-screen-xl mx-auto x-auto md:px-4 container flex items-center justify-between flex-wrap md:flex-nowrap">
                    <div className="text-indigo-500 md:order-1">
                        <h1 className="max-w-4xl mb-8 text-4xl font-light tracking-normal leading-tight md:text-[2.875rem] xl:text-[3.25rem] text-gray-800">
                            <>{t("banner.headline")}</>
                        </h1>
                        <hr className="h-[3px] w-[56px] border-t-0 bg-yellow-400 my-8" />
                        <p className="max-w-4xl font-light text-gray-700 md:text-lg lg:text-xl dark:text-gray-400">
                            <>{t("banner.intro")}</>
                        </p>
                        {oAuthUrl && (
                            <a
                                href={oAuthUrl}
                                className="mt-6 inline-flex px-6 py-2 bg-[#0079c1] hover:bg-[#005e95] text-white flex items-center gap-2 transition-colors duration-300"
                            >
                                <>{t("common.signin")}</>
                            </a>
                        )}
                    </div>
                </div>
            </nav>
        </>
    );
}
